import "../img/icons/facebook-green.svg";
import "../img/icons/print-green.svg";
import "../img/icons/twitter-green.svg";
import "../img/news.jpg";
